export const AllBlogs=[
    {
        title: 'Some javascript tricky thing',
        image:'https://miro.medium.com/max/875/1*jOd7Vu8FLw0hszpMiimoBw.jpeg',
        discription:'Today we learn some javascript tricky troth and all are most important for js interview, you will face this type of question if you going to an interview as a js developer',
        readMore:'https://shozonraj.medium.com/some-javascript-tricky-thing-26d9332b98c'
    },
    {
        title: '10 thing you have to know about react ',
        image:'https://miro.medium.com/max/875/1*rnUVxpfpns0T4IrB0Chnig.jpeg',
        discription:'As a beginner, it is common that everyone confused is reacted Never be confused with the react library of the framework. Actually, ReactJS is not a framework,',
        readMore:'https://shozonraj.medium.com/10-thing-you-have-to-know-about-react-as-a-beginner-4642a69e6578'
    },
    {
        title: 'JavaScript data type ',
        image:'https://miro.medium.com/max/875/1*I_WpcYybMHr3w0ACWJuW3A.jpeg',
        discription:'If you want to know javascript data type then at first you have to know the javascript variable because variable and data type is related to each other,So first you have to know what is JavaScript variable.',
        readMore:'https://shozonraj.medium.com/javascript-data-type-8ff40cabd438'
    },
    
]